import React from 'react'
import { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom'
import { useForm } from 'react-hook-form'
import { resetPasswordRequest } from '../../api/authorization.api'
import { showSuccess, showError } from '../../services/toastServices';
import { logout } from '../../services/authorizationService';


const ResetPasswordRequestPage = (props) => {
  const { register, handleSubmit, formState: { errors }, setValue } = useForm();
  const [emailSent, setEmailSent] = useState(false)
  const [email, setEmail] = useState(false)
  const navigate = useNavigate()
  
  
  useEffect(() => {
    logout()
    // eslint-disable-next-line react-hooks/exhaustive-deps
}, []);

  const handleRequestRestPassword = handleSubmit(async data => {
    setEmail(data.email)
    await resetPasswordRequest(data, resetPasswordRequestSuccess, resetPasswordRequestError)
  })

  const resetPasswordRequestSuccess = ((response)=>{
    showSuccess('Email y clave correctos')   
    setEmailSent(true)
  })

  const resetPasswordRequestError = ((error)=>{
    showError('Error de conexión')
    setEmail('')
    setEmailSent(false)
    if (!error.response) {
      // network error
      this.errorStatus = 'Error: Network Error';
    } else {
        this.errorStatus = error.response.data.message;
    }
  })
  const renderEmailSent = (()=>{
    if(!emailSent){
      return (<button className=' bg-blue-400 p-3 rounded-lg block w-full col-start-2 col-span-2 hover:bg-blue-500' onClick={handleRequestRestPassword}>Cambiar contraseña</button>)
    }else {
      return (<div className='col-start-2 col-span-2 mt-4 text-xl'><p>Se ha enviado un email a {email} con los pasos a seguir para cambiar la contraseña.</p></div>)
    }
  })

  return (
    <div className="mainContainer">
      <div className='mx-auto grid grid-cols-4 gap-x-2'>
        <div className='col-start-2 col-span-2'>
          <div className="flex justify-center py-3">
            <h1 className='font-bold'>Creación de nueva cuenta!</h1>
          </div>
        </div>
        <form action="" className='col-start-2 col-span-2'>
          <input
              type="text"
              placeholder="Email"
              {...register("email", { required: true })}
              className=' bg-blue-100 p-3 rounded-lg block w-full mb-3'
          />
          {errors.email && <span>Campo requerido</span>}
        </form>
        {renderEmailSent()}
      </div>
    </div>
  )
}

export default ResetPasswordRequestPage